import {Component, Input, OnInit} from '@angular/core';
import {DetailConfigurationField} from "../../../models/detail-configuration-field";
import {HelperService} from "../../../services/helperService";
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'tig-tabs-dynamic-form',
  templateUrl: './tabs-dynamic-form.component.html',
  styleUrls: ['./tabs-dynamic-form.component.scss']
})
export class TabsDynamicFormComponent implements OnInit {

  /**
   * Attributes
   */
  @Input()
  OBJ_field_config: DetailConfigurationField;
  @Input()
  OBJ_parent_form_group: FormGroup;
  @Input()
  STR_form_group_name: string;

  constructor(public OBJ_helper_service: HelperService)
  {}

  ngOnInit() {
  }

}
